/**
 * @fileoverview gRPC-Web generated client stub for acatspb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: acatspb/multicycle.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.acatspb = require('./multicycle_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acatspb.MultiCycleMROServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acatspb.MultiCycleMROServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acatspb.MultiCycleMRO,
 *   !proto.acatspb.ListMultiCycleMROResponse>}
 */
const methodDescriptor_MultiCycleMROService_ListMultiCycleMRO = new grpc.web.MethodDescriptor(
  '/acatspb.MultiCycleMROService/ListMultiCycleMRO',
  grpc.web.MethodType.UNARY,
  proto.acatspb.MultiCycleMRO,
  proto.acatspb.ListMultiCycleMROResponse,
  /**
   * @param {!proto.acatspb.MultiCycleMRO} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acatspb.ListMultiCycleMROResponse.deserializeBinary
);


/**
 * @param {!proto.acatspb.MultiCycleMRO} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acatspb.ListMultiCycleMROResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acatspb.ListMultiCycleMROResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acatspb.MultiCycleMROServiceClient.prototype.listMultiCycleMRO =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acatspb.MultiCycleMROService/ListMultiCycleMRO',
      request,
      metadata || {},
      methodDescriptor_MultiCycleMROService_ListMultiCycleMRO,
      callback);
};


/**
 * @param {!proto.acatspb.MultiCycleMRO} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acatspb.ListMultiCycleMROResponse>}
 *     Promise that resolves to the response
 */
proto.acatspb.MultiCycleMROServicePromiseClient.prototype.listMultiCycleMRO =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acatspb.MultiCycleMROService/ListMultiCycleMRO',
      request,
      metadata || {},
      methodDescriptor_MultiCycleMROService_ListMultiCycleMRO);
};


module.exports = proto.acatspb;

